import { defineMessages } from 'react-intl'

const scope = `procurify.platform.audit-log.features.get-audit-log.AuditLogListPresenter`

export default defineMessages({
  listAriaLabel: {
    id: `${scope}.listAriaLabel`,
    defaultMessage: 'Audit log',
  },
  loadingText: {
    id: `${scope}.loadingText`,
    defaultMessage: 'Loading...',
  },
  errorStateText: {
    id: `${scope}.errorStateText`,
    defaultMessage: 'Failed to load the audit log. Please try again.',
  },
})
